module.exports = __webpack_public_path__ + "static/desktop-ammohandgun-497013b3b95d1efb273a68ace7a755bc.png";